export default __webpack_public_path__ + "static/media/480_business03-it-web.391497dd.png";